import atendimentoDomiciliar from './atendimentoDomiciliar'
import atendimentoIndividual from './atendimentoIndividual'
import atendimentoOdontologico from './atendimentoOdontologico'
import atividadeColetiva from './atividadeColetiva'
import avaliacao from './avaliacao'
import cadastroDomiciliar from './cadastroDomiciliar'
import cadastroIndividual from './cadastroIndividual'
import exportacao from './exportacao'
import fichaComplementar from '@/router/atencao-basica/fichaComplementar'
import fichaVacinacao from './fichaVavinacao'
import mapaAtendimento from './mapaAtendimento'
import marcadorConsumoAlimentar from '@/router/atencao-basica/marcadorConsumoAlimentar'
import parametrizacao from './parametrizacao'
import procedimento from './procedimento'
import relatorioAcessoCuidadoProgramado from './relatorioAcessoCuidadoProgramado'
import relatorioAtendimentoOdontologico from './relatorioAtendimentoOdontologico'
import relatorioCadastroConsistente from './relatorioCadastroConsistente'
import relatorioEstatisticoAtendimento from './relatorioEstatisticoAtendimento'
import relatorioEstatisticoPacienteCadastrado from './relatorioEstatisticoPacienteCadastrado'
import relatorioInconsistencia from './relatorioInconsistencia'
import relatorioVisitaDomiciliar from './relatorioVisitaDomiciliar'
import visitaDomiciliar from './visitaDomiciliar'

export default [
    {
        path: 'atencao-basica',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...atendimentoDomiciliar,
            ...atendimentoIndividual,
            ...atendimentoOdontologico,
            ...atividadeColetiva,
            ...avaliacao,
            ...cadastroDomiciliar,
            ...cadastroIndividual,
            ...exportacao,
            ...fichaComplementar,
            ...fichaVacinacao,
            ...mapaAtendimento,
            ...marcadorConsumoAlimentar,
            ...parametrizacao,
            ...procedimento,
            ...relatorioAcessoCuidadoProgramado,
            ...relatorioAtendimentoOdontologico,
            ...relatorioCadastroConsistente,
            ...relatorioEstatisticoAtendimento,
            ...relatorioEstatisticoPacienteCadastrado,
            ...relatorioInconsistencia,
            ...relatorioVisitaDomiciliar,
            ...visitaDomiciliar,
        ]
    }
]
